module.exports = __webpack_public_path__ + "img/CAT_CHEMICAL_RAWMATERIAL.34a972e9.svg";